/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ConfirmBtnAccCreation from "../../../../../components/_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../../components/_utils/AccountCreationComponents/PanDetails";
import ActiveInactiveAssociatePopup from "../../../../../components/_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import GSTVerification from "../../../../Settings/GSTDetails";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";
import "./index.css";
import {
  resetGSTVerification,
  verifyGST,
} from "../../../../../redux/features/sharedResources/sharedResources";
import ICONS from "../../../../../assets/Icons";

const CreatePan = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  setLookupNext,
  lookupNext,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  disableCreateNext,
  setDisableCreateNext,
  previousId,
  beneLookError,
  setPreviousBankNo,
  setPayload,
  payload,
  GSTStatus,
  setGSTStatus,
  setNewData,
  type,
  panLookupLoading,
}) => {
  const dropDownOptions = [
    "Reimbursement account",
    "Field force account",
    "Beneficiary account",
    "Tax account",
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { gstVerificationData, gstVerificationLoading } = useSelector(
    (state) => state.sharedResources,
  );

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(dropDownOptions[0]);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [GSTLinked, setGSTLinked] = useState(false);

  const prefilledGST =
    viewAccountDetailData?.beneficiary_accounts?.[0]?.gstin_detail || "";

  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      gstVerificationData &&
      !gstVerificationLoading
    ) {
      let aa = payload?.gstin?.substring(
        GlobalConfiguration?.lengthCheckTwo,
        payload?.gstin?.length - GlobalConfiguration?.lengthCheckThree,
      );
      if (aa === panNumber && gstVerificationData?.status === true) {
        setDisableCreateNext(true);
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa !== panNumber && gstVerificationData?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (
      payload?.gstin?.length === GlobalConfiguration?.lengthCheckZero &&
      verifiedPan &&
      !verifyPANisLoading
    ) {
      setGSTStatus(null);
    }
  }, [
    gstVerificationData,
    GSTStatus,
    gstVerified,
    payload?.gstin,
    verifyPANisLoading,
    gstVerificationLoading,
  ]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(
        GlobalConfiguration?.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration?.lengthCheckThree,
      );
      if (!GSTStatus && GSTStatus != null) {
        BenEnableNextButton(true);
      } else if (GSTStatus && disableCreateNext && aa === panNumber) {
        BenEnableNextButton(false);
      }
    }
  }, [GSTStatus]);

  useEffect(() => {
    if (!beneLookData?.status) {
      let aa = payload.gstin.substring(
        GlobalConfiguration?.lengthCheckTwo,
        payload.gstin.length - GlobalConfiguration?.lengthCheckThree,
      );
      if (
        verifiedPan === true &&
        GSTStatus &&
        payload?.gstin?.length > GlobalConfiguration?.lengthCheckZero &&
        payload?.gstin?.length === GlobalConfiguration?.gstLength &&
        gstVerified === true &&
        aa === panNumber
      ) {
        BenEnableNextButton(false);
      } else if (
        !beneLookLoading &&
        !verifyPANisLoading &&
        beneLookError === true &&
        verifiedPan &&
        panNumber?.length === GlobalConfiguration?.panLength &&
        payload?.gstin?.length === GlobalConfiguration?.lengthCheckZero
      ) {
        BenEnableNextButton(false);
      } else {
        BenEnableNextButton(true);
      }
    }
  }, [gstVerified, GSTStatus]);

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData?.status === true) {
      const beneficiaryData =
        viewAccountDetailData?.reimbursement_accounts?.[0];
      if (beneficiaryData) {
        setPayload((prevPayload) => ({
          ...prevPayload,
          gstin: beneficiaryData.gstin_detail || "",
        }));

        if (beneficiaryData.gstin) {
          dispatch(
            verifyGST({
              gstin: beneficiaryData.gstin,
            }),
          );
        }
      }
    }
  }, [viewAccountDetailData, viewAccountDetailLoading, dispatch]);

  useEffect(() => {
    if (
      payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      !customErrors["gstin"] &&
      !gstVerificationData?.status === true &&
      !gstVerificationLoading
    ) {
      if (Validation.allowedGstin(payload?.gstin)) {
        dispatch(verifyGST({ search_string: payload?.gstin }));
      } else {
        setGSTStatus(false);
      }
    }
  }, [payload?.gstin, customErrors]);

  useEffect(() => {
    if (!gstVerificationLoading) {
      if (gstVerificationData?.status === true) {
        setGstVerified(true);
      } else if (gstVerificationData?.status === false) {
        setGstVerified(false);
      } else {
        setGstVerified(null);
      }
    }
  }, [gstVerificationData, gstVerificationLoading]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value.length === GlobalConfiguration?.lengthCheckOne
      ) {
        return;
      }

      if (
        newValue.length < GlobalConfiguration?.gstLength &&
        newValue.length > GlobalConfiguration?.lengthCheckZero
      ) {
        setGstVerified(false);
        setGSTStatus(false);
        setGSTLinked(false);
      }

      if (name === "gstin") {
        setLookupNext(false);
        dispatch(resetGSTVerification());
        if (
          name === "gstin" &&
          newValue.length < GlobalConfiguration?.gstLength &&
          newValue.length > GlobalConfiguration?.lengthCheckZero &&
          !gstVerified &&
          GSTStatus
        ) {
          setGSTStatus(false);
        } else if (
          newValue.length === GlobalConfiguration?.gstLength &&
          gstVerified &&
          !GSTStatus
        ) {
          setGSTStatus(true);
        }
      }
    }
  };

  useEffect(() => {
    if (
      payload?.gstin?.length > GlobalConfiguration?.lengthCheckZero &&
      payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      gstVerificationData?.status === true
    ) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (
      payload?.gstin?.length > GlobalConfiguration?.lengthCheckZero &&
      gstVerificationData?.errors
    ) {
      let errors = { ...customErrors };
      errors["gstin"] = gstVerificationData.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [gstVerificationData]);

  const isPanValid = verifiedPan === true;

  const isGstValid =
    payload?.gstin?.length === GlobalConfiguration?.lengthCheckZero || // GST optional
    (payload?.gstin?.length === GlobalConfiguration?.gstLength &&
      GSTStatus === true);

  const isConfirmDisabled = !isPanValid || !isGstValid;

  const isSwitchAccountLocked =
    type === "switch_account" &&
    prefilledGST?.length === GlobalConfiguration?.gstLength &&
    payload?.gstin === prefilledGST &&
    gstVerified === true;

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.forEach((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [beneLookData]);

  useEffect(() => {
    if (beneLookData?.beneficiary_accounts?.length > 0) {
      const accounts = beneLookData?.beneficiary_accounts || [];

      const foundAccount =
        accounts?.find((val) => val?.type_of_account === "field_force") ||
        accounts?.find((val) => val?.type_of_account === "reimbursement") ||
        accounts?.find((val) => val?.type_of_account === "beneficiary");

      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : "Beneficiary account",
      );
      setAccActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }
  }, [openAssociatePopup, beneLookData]);

  useEffect(() => {
    if (gstVerificationData?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: gstVerificationData?.gstin_details?.business_name,
      });
    }
  }, [gstVerificationData]);

  return (
    <div className="w-width-full">
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: gstVerificationData?.gstin_details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={gstVerificationData?.gstin_details?.gstin_no}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={verifyPANisLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePanChange(e);
              }}
              panDetails={panDetails}
              type={type}
            />
            <div
              className={`w-width-full ${!verifiedPan || isSwitchAccountLocked ? "opacity-light-opacity" : "opacity-base-opacity"}`}
            >
              <GstDetails
                verifiedPan={verifiedPan}
                gstVerified={gstVerified}
                beneVerifyGST={gstVerificationData}
                isGSTLoading={gstVerificationLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload?.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleChange}
                type={type}
                isSwitchAccountLocked={isSwitchAccountLocked}
                isInputDisabled={!verifiedPan}
              />
            </div>
          </div>

          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)] ${
              type === "switch_account"
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            {verifiedPan === true &&
              beneLookLoading === false &&
              verifyPANisLoading === false &&
              panLookupLoading === false && (
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      verifiedPan === false ? "" : "animate-slideInFromRight"
                    }
                  >
                    <ConfirmBtnAccCreation
                      type="pan"
                      status={beneLookData?.status}
                      lookupNext={type === "switch_account" ? true : lookupNext}
                      GSTStatus={GSTStatus}
                      isButtonDisabled={
                        type === "switch_account" ? false : isConfirmDisabled
                      }
                      isGSTLoading={gstVerificationLoading}
                      selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                      not_selected={ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE}
                      handleClick={() => {
                        if (
                          isConfirmDisabled ||
                          type === "switch_account" ||
                          gstVerificationLoading
                        )
                          return;
                        setIsApproved(false);
                        setLookupNext(true);
                        setIsArchived(false);
                        setIsDennied(false);
                        setIsPending(false);
                        setDisableCreateNext(false);
                        setDisableCreateNext(true);
                      }}
                    />
                  </div>
                </div>
              )}

            <ActiveInactiveAssociatePopup
              flow={
                verifiedPan === false
                  ? "hideAssociate"
                  : verifiedPan === null ||
                      beneLookLoading ||
                      verifyPANisLoading
                    ? "defaultPan"
                    : !beneLookLoading &&
                        !verifyPANisLoading &&
                        beneLookError === true &&
                        verifiedPan &&
                        panNumber?.length === GlobalConfiguration.panLength
                      ? "notFoundPan"
                      : "Pan"
              }
              dropDownNo={GlobalConfiguration?.lengthCheckOne}
              pan={payload?.panNumber}
              accActiveInactiveState={accActiveInactiveState}
              setAccActiveInactiveState={setAccActiveInactiveState}
              currentAssociate={currentAssociate}
              setCurrentAssociate={setCurrentAssociate}
              openAssociatePopup={openAssociatePopup}
              setOpenAssociatePopup={setOpenAssociatePopup}
              panLength={panNumber.length}
            />
          </div>
        </CommonLayout>
      </div>
    </div>
  );
};
export default CreatePan;
